import React from "react";
import { Card, CardBody, CardTitle } from "react-bootstrap";

import { Blog } from "../core/models/Blog";
import CategoryBadge from "./CategoryBadge";
import { WLink } from "./WLInk";

interface BlogElementProps {
    blog: Blog;
}

const BlogElement: React.FC<BlogElementProps> = ({ blog }) => {
    return <div
        style={{
            margin: 8,
            marginTop: 16,
            padding: 12,
            marginRight: "2vw",
            marginLeft: "2vw",
        }}
    >
        <WLink to={`/blog/${blog.id}`}>
            <Card style={{
                borderColor: blog.categories?.includes("project") ? "purple" : undefined,
            }}>
                <CardTitle style={{ margin: 12 }}>{blog.title}</CardTitle>
                <CardBody>
                    {blog.description && <p>{blog.description}</p>}
                    {blog.categories?.map(cat =>
                        <CategoryBadge cat={cat} />
                    )
                    }
                </CardBody>

            </Card>
        </WLink>
    </div>;
}

export default BlogElement;